import { useSelector } from 'react-redux';
import State from 'store/State';
import { selectAppState } from 'app/store/selectors';
import { AvailabilityStatusUpdate } from 'app/store/connectivity/ConnectivityState';

export const selectConnectivityState = (state: State) =>
    selectAppState(state).connectivity;

export const selectConnectivityStatus = (state: State) =>
    selectConnectivityState(state).current;

export const useNetworkConnectivityStatus = () =>
    useSelector((state: State) => {
        return selectConnectivityStatus(state);
    });

export const selectAvailabilityStatusHistory: (
    state?: State
) => AvailabilityStatusUpdate[] = (state) =>
    state ? selectConnectivityState(state).availabilityStatus : [];

export const selectAvailabilityStatus = (state: State) => {
    const history = selectAvailabilityStatusHistory(state);
    return history.length > 0 ? history[history.length - 1] : undefined;
};

export const useAvailabilityStatus = () =>
    useSelector(selectAvailabilityStatus);
